import * as React from "react";

import { cn } from "@/components/lib/css";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  maskMe?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, maskMe, value, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "rounded-button border-color-text-dimmed file:text-color-text-secondary placeholder:text-color-text-dimmed focus-visible:ring-ring aria-[invalid=true]:border-color-accent-negative aria-[invalid=true]:text-color-accent-negative flex h-[52px] w-full border bg-transparent px-3 pt-3 pb-1 text-sm/[14px] shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm/[14px] file:font-medium focus-visible:ring-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-[1.5px]",
          className
        )}
        {...(maskMe ? { "mask-me": "true" } : {})}
        ref={ref}
        value={value ?? ""}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
